import { Component, Inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { Row } from '../../interfaces/referral.interface';
import { lastValueFrom } from 'rxjs';
import { CollaborationService } from '../../services/collaboration.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatRowDef, MatRow } from '@angular/material/table';
import { DocViewerComponent } from '../doc-viewer/doc-viewer.component';
import { AssetUrlPipe } from '../../pipes/asset-url.pipe';
@Component({
    selector: 'app-file-details-dialog',
    templateUrl: './file-details-dialog.component.html',
    styleUrl: './file-details-dialog.component.scss',
    providers: [DatePipe],
    imports: [CdkScrollable, MatDialogContent, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatRowDef, MatRow, DocViewerComponent, AssetUrlPipe]
})
export class FileDetailsDialogComponent {


  fileElement: any;
  ELEMENT_DATA: Row[] = []
  isSubscribed: boolean = false;
  subscribe: string = "Subscribe"
  previewElement: any = null;
  constructor(
    public dialogRef: MatDialogRef<FileDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private datePipe: DatePipe,
    public collaborationService: CollaborationService
  ) {
    this.fileElement = data;
  }
  displayedColumns: string[] = ['name', 'value'];
  dataSource = this.ELEMENT_DATA;
  currentUserSubscribed: boolean = false;


  async ngOnInit() {
    this.subscribe = this.fileElement.contentFollowed ? 'Unsubscribe' : 'Subscribe';
    this.collaborationService.getUserProfilePicture(this.fileElement.user.email).subscribe({
      next: (response: any) => {
        this.fileElement.profilePictureUrl = response;
      }
    })
    // this.fileElement.contentFollowers = await Promise.all(this.fileElement.contentFollowers.map(async(user: any) => {
    //   if(user.id === this.fileElement.user.id) this.currentUserSubscribed = true;
    //   user.profilePictureUrl = await lastValueFrom(this.collaborationService.getUserProfilePicture('', user.email))
    //   return user;
    // }));
    let formattedDate = this.fileElement.modifiedAt ? this.datePipe.transform(this.fileElement.modifiedAt + "Z", 'MM/dd/yyyy h:mm a') : '';
    this.ELEMENT_DATA = this.data?.kind === 'note' ? [
      { name: 'Name', value: this.fileElement.name },
      { name: 'Kind', value: this.fileElement.kind },
      { name: 'Modified', value: formattedDate + ' by ' + this.fileElement.modifiedByName }
    ] : [
      { name: 'Name', value: this.fileElement.name },
      { name: 'Type', value: this.fileElement.blobMediaType },
      { name: 'Kind', value: this.fileElement.kind },
      { name: 'Size', value: this.fileElement.blobSize },
      { name: 'Modified', value: formattedDate + ' by ' + this.fileElement.modifiedByName }
    ]
  }



  close() {
    if (this.isSubscribed) {
      this.dialogRef.close(this.subscribe);
    }
    this.dialogRef.close(false);
  }

  previewDocument() {
    this.previewElement = this.fileElement;
  }
  onPreviewClose() {
    this.previewElement = null;
  }

  subscribeCall() {
    this.currentUserSubscribed = !this.currentUserSubscribed;
    this.isSubscribed = !this.isSubscribed;
    if (this.isSubscribed) {
      this.subscribe = "Unsubscribe"
    } else {
      this.subscribe = "Subscribe"
    }
  }

}
